/**
 * Masks ALL query parameters in a URL by replacing their values with '[MASKED]'
 * @param url - The URL to mask parameters in
 * @returns The URL with all parameters masked
 */
export const maskSensitiveQueryParams = (url: string): string => {
    try {
        const urlObj = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://localhost')
        const params = new URLSearchParams(urlObj.search)

        for (const [key, value] of params.entries()) {
            if (value) {
                params.set(key, '[MASKED]')
            }
        }

        urlObj.search = params.toString()
        return urlObj.toString()
    } catch (error) {
        console.warn('Error masking URL parameters:', error)
        return url
    }
}

/**
 * Checks if a URL contains any query parameters
 * @param url - The URL to check
 * @returns True if the URL contains any parameters
 */
export const hasSensitiveQueryParams = (url: string): boolean => {
    try {
        const urlObj = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://localhost')
        const params = new URLSearchParams(urlObj.search)

        return params.toString().length > 0
    } catch (error) {
        console.warn('Error checking URL parameters:', error)
        return false
    }
}

/**
 * Removes ALL query parameters from a URL
 * @param url - The URL to clean
 * @returns The URL with all parameters removed
 */
export const removeSensitiveQueryParams = (url: string): string => {
    try {
        const urlObj = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://localhost')
        urlObj.search = ''
        return urlObj.toString()
    } catch (error) {
        console.warn('Error removing URL parameters:', error)
        return url
    }
}
